<template lang="html">
  <v-dialog
    v-model="PasswordBotDialog"
    persistent
    :overlay="false"
    max-width="500px"
    transition="dialog-transition"
  >
    <v-card :style="stylechat">
      <v-card-title primary-title>
        {{$t('LeftSide.addFiend.headerCheckpass')}}
      </v-card-title>
      <v-card-text>
        <v-text-field
          name="name"
          :label="$t('LeftSide.addFiend.placeholderPassword')"
          v-model="password"
          clearable
          id="password"
          solo
          hide-details
          @keyup.enter="checkPassword(password)"
        ></v-text-field>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-row justify="center" align="center">
          <v-col cols="6" align="center">
            <v-btn class="btn-color-confirm" :disabled="password === '' || password === null" block text @click="checkPassword(password)">{{$t('AnswerQuestion.ok')}}</v-btn>
          </v-col>
          <v-divider vertical class="mt-1"></v-divider>
          <v-col cols="6" align="center">
            <v-btn class="btn-color-cancel" block text @click="closeDialog()">{{$t('AnswerQuestion.cancel')}}</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <ErrorAlert :ErrorDialog="ErrorDialog" :ErrorDialogDetail="ErrorDialogDetail" @closeAlertDialog="closeAlertDialog"/>
  </v-dialog>
</template>

<script>
import ErrorAlert from '@/components/Alert/Error'
export default {
  props: {
    PasswordBotDialog: Boolean,
    PasswordBotDetail: {}
  },
  data () {
    return {
      ErrorDialogDetail: {},
      ErrorDialog: false,
      tokenbot: '',
      password: '',
      stylechat: {
        "--PasswordBot-HeaderColor": "white",
        "--PasswordBot-TabBackground": "white",
        "--PasswordBot-Icon": "gray",
        "--PasswordBot-IconActive": "#2662ae",
        "--PasswordBot-Background": "white",
        "--PasswordBot-FontSize": "18px",
        "--PasswordBot-FontColor": "black",
        "--PasswordBot-FontSize-Status": "16px",
        "--PasswordBot-FontColor-Status": "grey",
        "--PasswordBot-Background-Input": "#E2E1E3",
        "--PasswordBot-Color-Button": "#EFF2FE",
        "--PasswordBot-FontColor-Button": "#2662ae",
        "--PasswordBot-FontColor-Button-Cancel": "#cb1002"
      },
    }
  },
  components: {
    ErrorAlert
  },
  watch: {
    PasswordBotDialog () {
      // console.log(this.PasswordBotDialog)
      // console.log(this.PasswordBotDetail)
      if (this.PasswordBotDialog) {
        this.tokenbot = this.PasswordBotDetail.user.tokenuser
      }
    }
  },
  methods: {
    closeAlertDialog () {
      this.ErrorDialog = false
    },
    closeDialog () {
      this.$emit('closeDialog', false)
    },
    checkPassword (key) {
      // console.log(key)
      if (key !== '' && key !== null) {
        this.axios.post(process.env.VUE_APP_API_MANAGE + '/check_password_bot', {
          tokenbot: this.tokenbot,
          password: key
        }).then((response) => {
          // console.log(response.data)
          if (response.data.status === 'success') {
            if (response.data.message === 'correct password') {
              this.$router.push(`/chat/${response.data.tokenroom}`)
            } else {
              this.ErrorDialogDetail = {
                title: 'Error',
                text: this.$t('LeftSide.addFiend.messageCheckbot')
              }
              this.ErrorDialog = true
            }
          } else {
            this.ErrorDialogDetail = {
              title: 'Error',
              text: response.data.message
            }
            this.ErrorDialog = true
          }
        }).catch(err => {
          console.log(err)
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        })
      }
    }
  }
}
</script>

<style lang="css" scoped>
.btn-color-confirm {
  color: var(--PasswordBot-FontColor-Button) !important;
  text-transform: none !important;
  font-weight: 600;
  font-size: var(--PasswordBot-FontSize) !important;
}
.btn-color-cancel {
  color: var(--PasswordBot-FontColor-Button-Cancel) !important;
  text-transform: none !important;
  font-size: var(--PasswordBot-FontSize) !important;
}
>>>.v-dialog {
  border-radius: 15px;
  margin: 24px;
  overflow: hidden;
  pointer-events: auto;
  width: 100%;
  z-index: inherit;
  outline: none;
}
>>>.v-input__slot {
  background-color: var(--PasswordBot-Background-Input) !important;
  border-radius: 10px !important;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: none !important;
}
</style>
